import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import NumberFormat from 'react-number-format';
import { Link as RouterLink } from 'react-router-dom';

import Checkbox from '@material-ui/core/Checkbox';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';

import './ClaimsTable.scss';

const ClaimsTable = ({
  checkedClaims,
  claimsList,
  enableExport,
  onCheck,
}) => (
  <div className="claims-table">
    <Table>
      <TableHead>
        <TableRow className="claims-table__header">
          {enableExport && (
            <TableCell />
          )}
          <TableCell>Claim number</TableCell>
          <TableCell>Schedule number</TableCell>
          <TableCell>Date filed</TableCell>
          <TableCell>Creditor</TableCell>
          <TableCell numeric>Amount of claim</TableCell>
          <TableCell>Status</TableCell>
          <TableCell>Debtor</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {claimsList.map(({
          amountOfClaim,
          claimNumber,
          creditor,
          dateFiled,
          debtor,
          id,
          scheduleNumber,
          status,
        }) => (
          <TableRow key={id}>
            {enableExport && (
              <TableCell
                numeric
                className="claims-table__checkbox"
                padding="checkbox"
              >
                <Checkbox
                  color="primary"
                  checked={checkedClaims.includes(id)}
                  onChange={() => {
                    onCheck([id]);
                  }}
                />
              </TableCell>
            )}
            <TableCell>
              <RouterLink
                className="claims-table__link"
                to={`claims/${id}`}
              >
                {claimNumber}
              </RouterLink>
            </TableCell>
            <TableCell>
              <RouterLink
                className="claims-table__link"
                to={`claims/${id}`}
              >
                {scheduleNumber}
              </RouterLink>
            </TableCell>
            <TableCell>{moment(dateFiled).format('L')}</TableCell>
            <TableCell>{creditor}</TableCell>
            <TableCell numeric>
              <NumberFormat
                value={amountOfClaim}
                displayType="text"
                prefix="$"
                thousandSeparator
              />
            </TableCell>
            <TableCell>{status}</TableCell>
            <TableCell>{debtor}</TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  </div>
);

ClaimsTable.propTypes = {
  checkedClaims: PropTypes.arrayOf(PropTypes.number).isRequired,
  claimsList: PropTypes.arrayOf(PropTypes.shape({
    amountOfClaim: PropTypes.string,
    claimNumber: PropTypes.string,
    creditor: PropTypes.string,
    dateFiled: PropTypes.sting,
    debtor: PropTypes.string,
    id: PropTypes.number,
    scheduleNumber: PropTypes.number,
    status: PropTypes.string,
  })).isRequired,
  enableExport: PropTypes.bool.isRequired,
  onCheck: PropTypes.func.isRequired,
};

export default ClaimsTable;



// WEBPACK FOOTER //
// ./src/routes/Case/Claims/ClaimsList/components/ClaimsTable/ClaimsTable.js